export default [
  {
    path: '/agenda/:imovelId',
    name: 'Agenda',
    component: () => import('./Agenda'),
    props: true,
    meta: {
      domain: 'Agenda',
      sidebar: false,
    },
  },
  {
    path: '/agenda/:veiculoId',
    name: 'AgendaVeiculo',
    component: () => import('./Agenda'),
    props: true,
    meta: {
      domain: 'Agenda',
      sidebar: false,
    },
  },
];



// WEBPACK FOOTER //
// ./src/app/Agenda/AgendaRouter.js